import { ReportData } from '../types/reportTypes';

// Cody Cline Direct Sales August 2025 Data
// IMPORTANT: Using 13% flat OH calculation (Contract Total � 0.13) retroactive to 1/1/2025
const jobData = [
  {
    jobInfo: "E-530: Joan Min",
    leadSource: "Referral- Cody's network",
    trade: "Painting & Others",
    contractTotal: 6336.63,
    grossMarginPct: 0.5091,
    grossProfit: 3225.98,
    commissionPercentage: 0,
    salesCommission: 0, // Will be calculated
    salesManagerFee: 0,
    companyOH: 6336.63 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-522: Pennrose Management Obery Court",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 7963.64,
    grossMarginPct: 0.6358,
    grossProfit: 5063.28,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 7963.64 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-545: Stephen Feldman",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 20969.00,
    grossMarginPct: 0.4337,
    grossProfit: 9094.26,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 20969.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-570: John Tabor Cooper Project C/O",
    leadSource: "Referral- Cody's network",
    trade: "Gutters",
    contractTotal: 4190.00,
    grossMarginPct: 0.3317,
    grossProfit: 1389.82,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 4190.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-548: John Tabor",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 8500.00,
    grossMarginPct: 0.6882,
    grossProfit: 5849.70,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 8500.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-554: Mary Hibicht",
    leadSource: "Previous Customer",
    trade: "Roofing",
    contractTotal: 3123.33,
    grossMarginPct: 0.3597,
    grossProfit: 1123.46,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 3123.33 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-557: Antony Blinken",
    leadSource: "Referral- Dominic's network",
    trade: "Painting & Others",
    contractTotal: 108481.90,
    grossMarginPct: 0.5130,
    grossProfit: 55651.21,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 108481.90 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-523: Michele Anglin",
    leadSource: "Referral- Cody's network",
    trade: "ROI Windows & Doors",
    contractTotal: 5549.92,
    grossMarginPct: 0.2519,
    grossProfit: 1398.02,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 5549.92 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-543: David Steckel",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 6999.00,
    grossMarginPct: 0.4286,
    grossProfit: 2999.77,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 6999.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-551: Chris Meckel Peirce Project",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 34818.56,
    grossMarginPct: 0.7585,
    grossProfit: 26409.88,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 34818.56 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-534: Kingsgate A Condominium, Inc",
    leadSource: "Referral- Dominic's network",
    trade: "Painting & Others",
    contractTotal: 63512.79,
    grossMarginPct: 0.3867,
    grossProfit: 24560.40,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 63512.79 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-504: William Daming",
    leadSource: "Referral- Dominic's network",
    trade: "Siding",
    contractTotal: 8060.00,
    grossMarginPct: 0.5095,
    grossProfit: 4106.57,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 8060.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-533: Ellicott Hills Condo 2",
    leadSource: "Referral- Dominic's network",
    trade: "Solar Install",
    contractTotal: 491.00,
    grossMarginPct: 0.4603,
    grossProfit: 226.01,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 491.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "S-3072: Hannah Lindsell",
    leadSource: "Site Survey Website",
    trade: "Solar Install",
    contractTotal: 36108.00,
    grossMarginPct: 0.3000,
    grossProfit: 10832.40,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 36108.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-541: Brad Hunter",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 13609.00,
    grossMarginPct: 0.4908,
    grossProfit: 6679.30,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 13609.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-549: Vince Sanudos",
    leadSource: "Referral- Dominic's network",
    trade: "Painting & Others",
    contractTotal: 7434.84,
    grossMarginPct: 0.5306,
    grossProfit: 3944.93,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 7434.84 * 0.13, // 13% flat rate
    netProfit: 0
  }
];

// Apply Cody Cline calculation formula
// For Cody reports: Net Profit = Gross Profit - Company OH
// Sales Commission = Net Profit � 2 (50% of Net Profit)
jobData.forEach(job => {
  job.netProfit = job.grossProfit - job.companyOH;
  job.salesCommission = job.netProfit / 2;
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap);

export const codySalesAugustData: ReportData = {
  kpis: {
    adSpend: 0, // No ad spend for Cody direct sales
    totalSales: totalContractValue,
    grossProfit: totalGrossProfit,
    salesCommissions: totalSalesCommissions,
    managerFees: 0, // No manager fees in Cody structure
    companyOH: totalCompanyOH,
    netProfit: totalNetProfit,
    netProfitPercent: totalNetProfit / totalContractValue,
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  adSpendBySource: [
    { source: "Referral- Cody's network", spend: 0 },
    { source: "Referral- Dominic's network", spend: 0 },
    { source: "Previous Customer", spend: 0 },
    { source: "Site Survey Website", spend: 0 }
  ],

  salesBySource: salesBySource,

  salesByTrade: salesByTrade,

  jobData: jobData,

  period: {
    month: 8,
    year: 2025
  }
};
